import { useEffect, useState } from 'react';

export function SvgSprite(): JSX.Element | null {
  const [loadError, setLoadError] = useState<boolean>(false);

  useEffect(() => {
    const loadSprite = async (): Promise<void> => {
      try {
        const response = await fetch('/sprite.svg');
        if (!response.ok) throw new Error('Failed to load sprite');

        const svgText = await response.text();
        const div = document.createElement('div');
        div.innerHTML = svgText;
        div.style.display = 'none';
        document.body.appendChild(div);
      } catch (error) {
        console.error('Error loading SVG sprite:', error);
        setLoadError(true);
      }
    };

    loadSprite().catch(console.error);

    return () => {
      const spriteElement = document.querySelector(
        'div:has(> svg[style="display: none;"])',
      );
      if (spriteElement) {
        spriteElement.remove();
      }
    };
  }, []);

  if (loadError) return null;
  return null;
}
